<template>
  <section
    class="ProductShipping"
    :class="[
      isZeborne ? 'zeborne' : 'mcp',
      (isRetailable === true) ? 'isRetailable' : 'isNotRetailable' ,
      {'isLead': isLead},
      {'isPac': isPac},
      {'notAvailable': !productShippingInfo.available }
    ]">
    <div class="desktopOnly">
      <div
        class="ProductShipping-cards ProductShipping-top-radius"
      >
        <!-- FLASH SELL -->
        <ProductShippingFlashSell></ProductShippingFlashSell>
      </div>
    </div>

    <form
      @submit.prevent="addProductToCart"
      ref="formAddProductToCart"
      class="ProductShipping-Form"
    >
      <div class="wrapper">
        <!-- INFO -->
        <div>
          <ProductShippingInfo></ProductShippingInfo>
        </div>

        <div class="plus-separator"><span>+</span></div>

        <!-- ADDITIONAL STANDART RELATED PRODUCT (Only on zeborne) -->
        <div  
          v-if="isZeborne && additionalProduct.standard_related_product && additionalProduct.standard_related_product[0] && additionalProduct.standard_related_product[0].entity_id != null "
        >
          <div 
            v-for="(additionalProductLine, index) in additionalProduct.standard_related_product" 
            :key="index"
            class="line-sup"
          >
            <div class="label big">{{additionalProductLine.name}}
              <span v-if="additionalProductLine.short_description && additionalProductLine.short_description != ''" class="info-bulle_container">
                  <i class="icon icon-infobulle"></i>
                  <span class="info-bulle">
                      <p>{{ additionalProductLine.short_description }}</p>
                  </span>
              </span>
            </div>
            <div class="data price priceBig" :inner-html.prop="additionalProductLine.final_price[productCurrentTva] | formatPrice(2)"></div>
          </div>
        
          <div class="plus-separator" v-if="additionalProduct.standard_related_product && additionalProduct.standard_related_product[0].entity_id != null"><span>+</span></div>
        </div>

        

        <!-- SHEET -->
        <div class="ProductShipping-cardsCollumn ProductShipping-bottom-radius">
          <ProductShippingMethods
            :hasDeliveryStrate="hasDeliveryStrate"
            :hasInstallationStrate="hasInstallationStrate"
            @shipping-method-selected="setShippingMethodChecked"
          ></ProductShippingMethods>
        </div>
      </div>
    
      <!-- Les + mon chauffagiste -->
      <ProductShippingPromo v-show="!isZeborne"></ProductShippingPromo>
      
      <!-- Aides de l'etat -->
      <ProductStateAid></ProductStateAid>
      

      <div class="ProductShipping-cardsCollumn ProductShipping-bottom-radius">
        <ProductShippingResume :fromProductPage="fromProductPage"></ProductShippingResume>
      </div>
    </form>

    <ProductPushCom v-if="hasPushCom()"></ProductPushCom>

    <!-- <transition name="slide-fade">
      <ModalRecapCart
        :showModal="showModal"
        v-if="showModal"
        :class="'Modal-right'"
        @ModalRecapCart::close="closeModal"
      ></ModalRecapCart>
    </transition> -->

    <!-- Modal Info -->
    <transition name="slide-fade">
      <ModalConfirm
        v-if="showModalConfirm"
        :showModal="showModalConfirm"
        @Modal::close="closeModalConfirm"
        @Modal::update="updateConsents"
        :content="modalContentConfirm"
      ></ModalConfirm>
    </transition>
  </section>
</template>

<script>
import "@/components/Product/ProductShipping/ProductShipping.scss";

import { mapGetters } from "vuex";

import ProductShippingFlashSell from "@/includes/Product/ProductShippingFlashSell/ProductShippingFlashSell.vue";
import ProductShippingInfo from "@/includes/Product/ProductShippingInfo/ProductShippingInfo.vue";
import ProductShippingMethods from "@/includes/Product/ProductShippingMethods/ProductShippingMethods.vue";
import ProductShippingPromo from "@/includes/Product/ProductShippingPromo/ProductShippingPromo.vue";
import ProductShippingResume from "@/includes/Product/ProductShippingResume/ProductShippingResume.vue";
/* import ModalRecapCart from "@/components/Modal/ModalRecapCart.vue"; */
import addProductToCartMixin from "@/mixins/actions/product/addProductToCartMixin.js";
import ProductPushCom from "@/components/Product/ProductPushCom/ProductPushCom.vue";
import ProductStateAid from '@/includes/Product/ProductStateAid/ProductStateAid.vue';

export default {
  name: "ProductShipping",

  mixins: [addProductToCartMixin],

  data() {
    return {
      shippingMethodChecked: '',
    };
  },

  components: {
    ProductShippingFlashSell,
    ProductShippingInfo,
    ProductShippingMethods,
    ProductShippingPromo,
    ProductShippingResume,
    /* ModalRecapCart, */
    ProductPushCom,
    ProductStateAid,
  },

  props: {
    hasDeliveryStrate: {
      type: Boolean,
      default: false
    },
    hasInstallationStrate: {
      type: Boolean,
      default: false
    },
    fromProductPage: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({ productReviewsAverage: "getProductReviewsAverage" }),
    ...mapGetters({ productFlashSell: "getProductFlashSell" }),
    ...mapGetters({ pushComObj: "getPushCom" }),
    ...mapGetters({ isZeborne: "isZeborne" }),
    ...mapGetters({ extendedWarranty: "getProductExtendedWarranty" }),
    ...mapGetters({ additionalProduct: "getProductAdditionalProduct" }),
    ...mapGetters({productCurrentTva: "getProductTVAForCurrentDelivery" }),
    ...mapGetters({ isLead: "isLead"}),
    ...mapGetters({isRetailable: "getProductIsRetailable"}),
    ...mapGetters({productShippingInfo: "getProductShippingInfo"}),
    ...mapGetters({ isPac: "isPac"}),
    ...mapGetters({ productUniverse: "getProductUniverse"}),
  },

  methods: {
    isShoppingNoticeVisible() {
      if (
        (this.productFlashSell &&
          this.productFlashSell.endFlashSell &&
          this.productFlashSell.startFlashSell &&
          this.isFlashSellActive()) ||
        (this.productReviewsAverage &&
          this.productReviewsAverage.count > 0 &&
          this.productReviewsAverage.rate)
      ) {
        return true;
      }

      return false;
    },
    hasPushCom() {
      if (this.pushComObj.pushCom) {
        return true;
      }
      return false;
    },
    isFlashSellActive() {
      if (this.productFlashSell && this.productFlashSell.endFlashSell !== "") {
        let now = this.$dayjs(new Date());
        let endDate = this.$dayjs(this.productFlashSell.endFlashSell);
        if (endDate.isAfter(now)) {
          return true;
        }
      }

      return false;
    },

    setShippingMethodChecked(method) {
      this.shippingMethodChecked = method
    },
  },
};
</script>